import { render } from "./ListeSuiviClientPage.vue?vue&type=template&id=a6871f32&ts=true"
import script from "./ListeSuiviClientPage.vue?vue&type=script&lang=ts"
export * from "./ListeSuiviClientPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__